// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"CreateEntityForm_formWrapper__2TbhV","form":"CreateEntityForm_form__3UqDQ","content":"CreateEntityForm_content__1lN81"};